module.exports = __webpack_public_path__ + "static/img/ticket_expired.2c0e5329.png";